import AwsConfig from '../../Config/AwsConfig'
import { truevalueedit } from '../Movie/truevalueedit'

export function PersonReview(submitvalues, input) {
  truevalueedit(
    [true, submitvalues.yousayPersonReviewURL_Te ? submitvalues.yousayPersonReviewURL_Te : ''],
    input,
    'yousayPersonReviewURL_Te',
  )
  truevalueedit(
    [true, submitvalues.yousayPersonReviewURL_En ? submitvalues.yousayPersonReviewURL_En : ''],
    input,
    'yousayPersonReviewURL_En',
  )
  truevalueedit(
    [
      true,
      submitvalues.personArticleReviewTitle_En ? submitvalues.personArticleReviewTitle_En : '',
    ],
    input,
    'personArticleReviewTitle_En',
  )
  truevalueedit(
    [
      true,
      submitvalues.personArticleReviewTitle_Te ? submitvalues.personArticleReviewTitle_Te : '',
    ],
    input,
    'personArticleReviewTitle_Te',
  )

  return input
}

export const GalleryImages = (inputData, input) => {
  if (inputData.GalleryImages && inputData.GalleryImages.length > -1) {
    const galleryImages = inputData.GalleryImages.map(e => ({
      path: e.path.replace(AwsConfig.movieCdnUrl, ''),
      title: e.title,
      // galleryTags: e.galleryTags,
      ...(e.galleryTags && e.galleryTags.length > 0 && { galleryTags: e.galleryTags }),
    }))
    input.galleryImages = galleryImages

    // truevalueedit([true, inputData.GalleryImages], input, 'galleryImages')
  }

  return input
}
